/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import Video from './modules/video'
_('video', 'element').nodes().map((el) => new Video(el))

This is just to make sure the 404 video auto plays on mobile

*/

export default class Video404 {
    constructor(el) {
        this.el = el

        this.el.muted = true
        this.el.play()
    }
}
